<div class="col-11 col-md-5 bg-white rounded-more m-auto p-4">
    <form class="" [formGroup]="registerForm" (ngSubmit)="register()">
        <div class="mb-3">
            <label for="username" class="form-label">Username<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="username" formControlName="username" (input)="clearError()">
        </div>
        <div class="mb-3">
            <label for="email" class="form-label">Email address<span class="text-danger">*</span></label>
            <input type="email" class="form-control" id="email" aria-describedby="emailHelp" formControlName="email" (input)="clearError()">
            <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
          </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password<span class="text-danger">*</span></label>
          <input type="password" class="form-control" id="password" formControlName="password" (input)="clearError()">
        </div>
        <!-- <div class="mb-3">
            <label for="referrer" class="form-label">Referal code</label>
            <input type="text" class="form-control" id="referrer" formControlName="referrer" (input)="clearError()" placeholder="(optional)">
          </div> -->
        <!-- <div class="mb-3">
            <label for="confirmPassword" class="form-label">Confirm Password<span class="text-danger">*</span></label>
            <input type="password" class="form-control" id="confirmPassword">
        </div> -->
        <!-- <div class="mb-3 text-center">
            Already have an account? <span class="text-primary py-2 cursor-pointer" [routerLink]="['/']" >Login</span> instead.
        </div> -->
        <div class="text-center text-success small mb-3" *ngIf="successMailSent">{{mailSentMessage}}</div>
        <div class="text-center text-danger small mb-3" *ngIf="error">{{errorMessage}}</div>
        <div class="d-flex justify-content-center">
            <button type="submit" class="btn btn-primary" [disabled]="registerForm.invalid">Register</button>
        </div>
    </form>    
    <img src="https://apoxymedia.net/p.ashx?o=1213&e=355&f=img&t=LEAD_ID" width="1" height="1" border="0" *ngIf="showPixel" />
    <!-- <img src="../../assets/images/bitssa.png" alt="" *ngIf="showPixel"> -->
</div>
